import classNames from 'classnames/bind';

import styles from './S05.module.scss';

const cx = classNames.bind(styles);

const S05 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <div className={cx('text')}>
          <span>100% 국내산 통 귀리와 볶은 보리</span>를 블렌딩하여
          <br />
          제대로 고소한 맛을 내기 위해 노력하였습니다.
        </div>
      </div>
    </div>
  );
};

export default S05;
